import { SHistoryLink } from 'pages/PageDashboard/components/styled';
import styled from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';

import { SText } from 'components/styled/SText';

export const HistoryArticle = styled.article`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  border-radius: 24px;
  background-color: ${EColors.White};

  @media (max-width: ${BreakPoint.TabletTop}) {
    gap: 16px;
    padding: 16px;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    flex-direction: column;
  }
`;

export const Title = styled(SText)`
  display: flex;
  align-items: center;
  gap: 4px;
  grid-area: title;
  font-family: ${FontFamily.Montserrat};
  font-size: 24px;
  font-weight: 800;
  line-height: 32px;
  color: ${EColors.Gray1Text};

  & svg {
    flex-shrink: 0;
  }

  @media (max-width: ${BreakPoint.TabletTop}) {
    font-size: 18px;
    line-height: 24px;

    & svg {
      width: 24px;
      height: 24px;
    }
  }
`;

export const HistoryLink = styled(SHistoryLink)`
  justify-self: end;

  @media (max-width: ${BreakPoint.MobileTop}) {
    justify-self: center;
    width: 100%;
  }
`;
